






































































































import Vue from 'vue';
import Component from 'vue-class-component';

import Swiper from 'swiper';

import dateEnfantService from '@/services/dateEnfantService';

import LottieAnimation from '@/components/LottieAnimation.vue';

const Props = Vue.extend({
	props: {
		enfant: {
			type: Object,
			default: function() {
				return { prenom: 'inconnu' };
			}
		},
		moisSel: {
			type: String,
			default: ''
		}
	}
});

@Component({
	components: {
		LottieAnimation
	}
})
export default class Subheader extends Props {

	swiper = null as any;

	periodeEnCours = dateEnfantService.indexAffichageEnCours(this.enfant.ddn);

	periodeSelectionnee = 0;

	ageEnmois = dateEnfantService.ageEnMois(this.enfant.ddn);

	/* fleche affichee de la naissance à 4 ans */
	affichageFleche = (this.ageEnmois<60);

	imageName() {
		/* moins de 3 ans */
		if (this.ageEnmois<36) {
			return 'pieds-bebe.jpg';
		} else if (this.ageEnmois<84) {
			/* moins de 7 ans */
			return 'nounours.jpg';
		}
		/*le reste*/
		return 'fille-ecriture.jpg';
	}

	mounted() {
		/*initialisation du swiper*/
		this.swiper = new Swiper('.swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 10,
			grabCursor: true,
			centeredSlides: true,
			on : {
				touchStart : () => {
					this.affichageFleche = false;
				}
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false
			}
		});
		/* si pas de mois selectionné alors on positionnne sur le mois de l'enfant */
		if (this.moisSel == '') {
			var mois = dateEnfantService.moisAffichage(this.enfant.ddn);
			this.select(dateEnfantService.indexAffichageMoisSel(''+mois));
			this.periodeSelectionnee = dateEnfantService.indexAffichageMoisSel(''+mois);
			this.$router.replace({ name: 'home-sante-enfant', query: { moisSel: mois+'' }});
		} else {
			/* on se positionne sur le mois selectionné */
			this.periodeSelectionnee = dateEnfantService.indexAffichageMoisSel(this.moisSel);
			this.select(this.periodeSelectionnee);
		}
	}
	select(index: number) {
		this.periodeSelectionnee = dateEnfantService.indexAffichageMoisSel(this.moisSel);
		/** gestion spécifique du slide : de 1 à 3 aligné à gauche */
		if (index<4) {
			/* 3 et 4 le slide ne bouge pas */
			this.swiper.setTranslate(0);
		} else if (index>3 && index<15) {
			/* 5 et plus on centre */
			this.swiper.slideTo(index);
		} else {
			this.swiper.slideTo(14);
		}
	}
	onScroll() {
		alert('toto');
	}
}
